import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { CheckCircleIcon, Copy } from 'lucide-react';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


 const ViewHtmlDialog = ({ openDialog, htmlCode, onClose, copy, setCopy }) => {

  const handleCopy = () => {
    if (htmlCode) {
      navigator.clipboard.writeText(htmlCode)
        .then(() => {
          // Optionally, you can show a success message here
          console.log("Copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };

  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      maxWidth="sm"
      fullWidth={true}
      PaperProps={{ sx: { maxWidth: 500, width: "100%" } }}
    >
      <DialogTitle sx={{ m: 0, p: 1.5, position: "relative" }}>
        HTML Template
        {copy && <Button
          autoFocus
          onClick={()=>{handleCopy(); setCopy(false);}}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            minWidth: "auto",
            padding: "4px",
            borderRadius: "50%",
            color: "inherit",
            fontSize: "0.8rem",
          }}
        >
          <Copy style={{ fontSize: "1.1rem" }} />
        </Button>}

      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          backgroundColor: "#121212",
          color: "#e0e0e0",
          fontFamily: "monospace",
          whiteSpace: "pre-wrap",
          minHeight: "150px",
          p: 2,
        }}
      >
        <Typography gutterBottom sx={{ fontSize: "0.9rem" }}>
                    {htmlCode}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", p: 1 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{ fontSize: "0.8rem" }}
        >
          Close
        </IconButton>
      </DialogActions>
    </BootstrapDialog>
  );
};



export default ViewHtmlDialog;